export function todayISO(d = new Date()) {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function daysBetween(aISO, bISO) {
  const [ay, am, ad] = aISO.split("-").map(Number);
  const [by, bm, bd] = bISO.split("-").map(Number);
  const a = Date.UTC(ay, am - 1, ad);
  const b = Date.UTC(by, bm - 1, bd);
  return Math.floor((b - a) / (24 * 60 * 60 * 1000));
}

export function clamp(n, min, max) {
  return Math.max(min, Math.min(max, n));
}

export function monthMatrix(year, monthIndex) {
  const first = new Date(year, monthIndex, 1);
  const firstDay = first.getDay(); // 0 Sun .. 6 Sat
  const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
  const weeks = [];
  let dayCounter = 1 - firstDay;

  for (let w = 0; w < 6; w++) {
    const week = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(year, monthIndex, dayCounter);
      week.push({
        date,
        inMonth: date.getMonth() === monthIndex,
        iso: todayISO(date),
      });
      dayCounter++;
    }
    weeks.push(week);
    const lastCell = week[6];
    if (lastCell.inMonth && lastCell.date.getDate() >= daysInMonth) break;
  }

  return weeks;
}
